import React from 'react'
import { Button } from 'components/ui'
import styles from './PublishingLoader/styles.module.css'
import useLocaleText from 'components/useLocaleText'
import { PublishingLoader } from './PublishingLoader'

const literals = {
  title: { key: 'task_publishing', fallback: { en: 'Publishing your task to recipients' } },
  subtitle: { key: 'task_publishing_sub', fallback: { en: 'This usually takes a few seconds' } },
}

export const TaskPublishingOverlay: React.FC<{ title?: string; subtitle?: string; complete?: boolean }> = ({
  title,
  subtitle,
  complete,
}) => {
  const text = useLocaleText(literals)
  return <PublishingLoader title={title ?? text.title} subtitle={subtitle ?? text.subtitle} complete={complete} />
}

/** Header action stays mounted while the settings form/portal is replaced by the overlay. */
export function TaskPublishingButton() {
  const { busy } = useLocaleText({ busy: { key: 'task_settings_busy', fallback: { en: 'Publishing…' } } })
  return (
    <Button
      type="button"
      isDisabled
      bg="#1d1f22"
      height="36px"
      _disabled={{ opacity: 0.85, cursor: 'wait' }}
      startIcon={<span className={styles.spinner} aria-hidden="true" />}
    >
      {busy}
    </Button>
  )
}
